module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_VIANDE.4cca53f6.svg";